import { buildCssClassName } from "@/3514/utils"

export default {
    holder: (): string =>
        buildCssClassName(
            "fixed",
            "bottom-[10px]",
            "lg:bottom-[15px]",
            "right-[10px]",
            "lg:right-[5px]",
            "shadow-sm",
            "lg:bg-gray-500/50",
            "z-[9999]",
            "lg:px-[5px]",
            "rounded-[10px]",
            "flex",
            "flex-col",
            "gap-[10px]",
            "overflow-y-auto",
            "max-h-[85px]",
            "lg:max-h-[calc(100%-20px)]",
            "no-scrollbar"
        )
}
